import { GuardarInfoPersonal, GuardarInfoTarjetas } from "../models";
import { instance} from "./base.api";
import { 
    CONFIRMAR_TOKEN_EMAIL,
    CONFIRMAR_TOKEN_SMS, 
    CUIT_SELECCIONADO, 
    GET_LOCALIDADES_BY_PROVINCIAS, 
    GET_OBTENER_CP_DE_LOCALIDAD, 
    GET_PROVINCIAS, 
    GET_PROVINCIA_DESC, 
    INICIO_TRAMITE, 
    PRE_INFO_TARJETAS,
    PRE_INFO_PERSONAL,
    SAVE_INFO_PERSONAL,
    TERMINOS_Y_CONDICIONES,
    SAVE_INFO_TARJETAS,
    RE_ENVIO_TOKEN,
    GET_PRODUCTOS_IMAGENES_BASE64,
    REENVIAR_LINK_REVISA_TU_TELEFONO} from "./endpoints";



export const setBaseURL = (newBaseURL: string) => {
    instance.defaults.baseURL = newBaseURL;
};


export const onboardingTarjetasApi = {

    iniciarTramite: function(dni:string, ddn:string, celular:string, producto: number, codigoReferido: string, esBCSAWEB: string, monto: number, utmParams: Record<string, string>){
        return instance.post(INICIO_TRAMITE,{dni, ddn, celular, producto, codigoReferido, esBCSAWEB, monto, utmParams});
    },
    cuitSeleccionado:function(idtramite:string, cuit:string){
        return instance.post(CUIT_SELECCIONADO, {idtramite, cuit});
    },
    reEnviarToken: function(idtramite:string, nroTelefono:string){
        return instance.post(RE_ENVIO_TOKEN, {idtramite, nroTelefono});        
    },
    confirmarToken: function(token:string, idTramite:string){
        return instance.post(CONFIRMAR_TOKEN_SMS, {token, idTramite});
    },
    preInfoTarjetas: function(idtramite:string)    {
        return instance.post(PRE_INFO_TARJETAS,{idtramite});
    },   
    saveInfoTarjetas: function(infotarjetas:GuardarInfoTarjetas){
        return instance.post(SAVE_INFO_TARJETAS, infotarjetas );
    }, 
    preInfoPersonal: function(idtramite:string)    {
        return instance.post(PRE_INFO_PERSONAL,{idtramite});
    },
    saveInfoPersonal: function(infopersonal:GuardarInfoPersonal){
        return instance.post(SAVE_INFO_PERSONAL, infopersonal );
    },
    reEnviarTokenEmail: function(idtramite:string, email:string){
        return instance.post(RE_ENVIO_TOKEN, {idtramite, email});        
    },
    confirmarTokenEmail: function(token:string, idtramite:string){
        return instance.post(CONFIRMAR_TOKEN_EMAIL, {token, idtramite});        
    },
    reEnviarLink: function(celular:string, idtramite:string){
        return instance.post(REENVIAR_LINK_REVISA_TU_TELEFONO, {celular, idtramite});        
    },
    Getprovincias:function(){
        return instance.get(GET_PROVINCIAS)
    }, 
    GetDatosProvincia: function(descProvicia:string){
        return instance.get(`${GET_PROVINCIA_DESC}/${descProvicia}`);
    }, 
    GetLocalidadByProvincia: function(idProvincia:number){
        return instance.get(`${GET_LOCALIDADES_BY_PROVINCIAS}/${idProvincia}`);
    }, 
    GetCPLocalidad: function(idLocalidad:number){
        return instance.get(`${GET_OBTENER_CP_DE_LOCALIDAD}/${idLocalidad}`);
    }, 
    GetTerminos:function(){
        return instance.get(TERMINOS_Y_CONDICIONES);
    },
    GetImagenesTarjetas:function(codigoReferido:string){
        return instance.get(`${GET_PRODUCTOS_IMAGENES_BASE64}?inputs=${codigoReferido}`);
    }
}